// project import
import { lazy } from "react";

import Loadable from "@/components/Loadable";
import MinimalLayout from "@/layouts/MinimalLayout";
import AuthenticationLinkExpired from "@/pages/authentication/link-expired";

// render - login
const AuthLogin = Loadable(lazy(() => import("@/pages/authentication/Login")));
const AuthForgotPassword = Loadable(lazy(() => import("@/pages/authentication/ForgotPassword")));
const AuthCheckMail = Loadable(lazy(() => import("@/pages/authentication/CheckMail")));
const AuthActionHandler = Loadable(
  lazy(() => import("@/pages/authentication/components/ActionHandler"))
);
const Onboarding = Loadable(lazy(() => import("@/pages/authentication/onboarding")));
// const AuthRegister = Loadable(
//   lazy(() => import("@/pages/authentication/Register"))
// );

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: "/auth",
  element: <MinimalLayout />,
  children: [
    {
      path: "login",
      element: <AuthLogin />,
    },
    {
      path: "forgot-password",
      element: <AuthForgotPassword />,
    },
    {
      path: "check-mail",
      element: <AuthCheckMail />,
    },
    {
      path: "link-expired",
      element: <AuthenticationLinkExpired />,
    },
    // TODO
    // {
    //   path: 'register',
    //   element: <AuthRegister />
    // },
    {
      path: "action",
      element: <AuthActionHandler />,
    },
    {
      path: "onboarding",
      element: <Onboarding />,
    },
  ],
};

export default LoginRoutes;
